"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as h } from "react";
import v from "../components/Icon/SvgIcon.js";
const m = (o) => /* @__PURE__ */ c(
  v,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.783 17.044c.524 0 .967-.352.967-.769V7.91c0-.417-.443-.769-.967-.769H4.218c-.525 0-.968.352-.968.769v8.365c0 .417.443.769.968.769h.794v-2.763c0-1.069.944-1.939 2.105-1.939h9.766c1.161 0 2.105.87 2.105 1.939v2.763zm-2.9 3.687c.464 0 .855-.315.855-.688v-5.762c0-.373-.391-.689-.855-.689H7.117c-.464 0-.855.316-.855.689v5.762c0 .373.391.688.855.688zM7.145 4.25a.884.884 0 0 0-.883.882v.759h11.476v-.759a.883.883 0 0 0-.882-.882zm11.843 1.641h.795c1.222 0 2.217.905 2.217 2.019v8.365c0 1.113-.995 2.019-2.217 2.019h-.795v1.749c0 1.069-.944 1.938-2.105 1.938H7.117c-1.161 0-2.105-.869-2.105-1.938v-1.749h-.794C2.995 18.294 2 17.388 2 16.275V7.91c0-1.114.995-2.019 2.218-2.019h.794v-.759C5.012 3.957 5.968 3 7.145 3h9.711c1.176 0 2.132.957 2.132 2.132zm-2.044 3.952a.975.975 0 1 0 1.949 0 .975.975 0 0 0-1.95 0m-8.891 6.34h7.895a.625.625 0 0 0 0-1.25H8.053a.625.625 0 0 0 0 1.25m7.895 3.207H8.053a.625.625 0 0 1 0-1.25h7.895a.625.625 0 0 1 0 1.25",
        clipRule: "evenodd"
      }
    )
  }
), l = h(m);
export {
  l as Print,
  l as default
};
